import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { InternationalisationService } from "../../forked/angular-internationalisation";

export class MenuSettingViewModel {
  public id: number; // used for defining tabs in html
  public labelDE: string;
  public labelEN: string;
  public get label() {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.labelEN) ? this.labelDE : this.labelEN;
  }
  public contentDE: string;
  public contentEN: string;
  public get content() {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.contentEN) ? this.contentDE : this.contentEN;
  }
}

// Requests
export class MenuSettingsSyncModel extends SyncModel {
}

// Responses
/** Only one MenuSettings exists and it has the id=0 (this const is used for selecting the MenuSettings) */
export const MenuSettingsDMKey: number = 0;

/** Sortierung der Artikel */
export enum MenuSettings_SortType {
  Alphabetic = 0,
  Itemnumber = 1,
  FreeItemnumber = 2,
}

export class MenuSettingsDataModel2 extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public sortiment: string;
  public use_description: boolean; // it is not used in the app
  public use_co2: boolean;
  public use_app_description: boolean; // this field use as description in App
  public use_additives: boolean;
  public use_allergens: boolean;
  public use_nutrition_values: boolean;
  public use_eCommerce: boolean = true;
  public sort_type: number; // MenuSettings_SortType
  public locations: number[];
  public browse_default_pe: number;
  public pickup_default_pe: number;
  public delivery_default_pe: number;
  public inhouse_default_pe: number;
  public orderahead_default_pe: number;
  /** Sollen artikel kennzeichnungen verwendet werden.
   * (item_provider_name, item_provider_addr, item_base_unit,
   * item_base_factor, item_caffeine, item_alcohol)
   */
  public use_article_label: boolean;
  /** abfragen mit Bildern darstellen */
  public extra_as_image: boolean = true; //! defaultwert entfernen wenn eingebaut  */
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class MenuSettingsSyncDataModel2 extends SyncDataModel {
  public settings: MenuSettingsDataModel2[];
  public get models(): DataModel[] { return this.settings; }
  public DeserializeType(): void {
    this._DeserializeType(MenuSettingsDataModel2);
  }
}
